module.exports = __webpack_public_path__ + "img/9-08.28645f9f.jpg";